import React from "react";
import { motion } from "framer-motion";
import { Quote } from "lucide-react";

const testimonial = {
  content:
    "Square Trigger helped improve our website structure and digital visibility. Their process was clear, professional, and focused on results.",
  author: "Einsured.ca",
};

export const TestimonialsSection = () => {
  return (
    <section className="relative overflow-hidden bg-muted/30 py-12 sm:py-14 lg:py-16">
      {/* Background */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute -top-24 left-10 h-72 w-72 rounded-full bg-primary/5 blur-3xl" />
        <div className="absolute -bottom-24 right-10 h-72 w-72 rounded-full bg-secondary/5 blur-3xl" />
      </div>

      <div className="container-custom relative z-10">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="mb-10 text-center sm:mb-12"
        >
          <span className="text-sm font-medium uppercase tracking-wider text-primary">
            Testimonials
          </span>
          <h2 className="mt-3 mb-4 text-3xl font-display font-bold text-foreground md:text-4xl lg:text-5xl sm:mb-6">
            What Our <span className="gradient-text">Clients Say</span>
          </h2>
        </motion.div>

        {/* Single Testimonial */}
        <div className="rounded-[28px] border border-border/70 bg-card/40 px-5 py-10 shadow-soft backdrop-blur-sm sm:px-8 sm:py-12 lg:px-12 lg:py-14">
          <div className="mx-auto max-w-[1000px]">
            <div className="relative pt-6 sm:pt-8">
              {/* Quote Icon */}
              <div className="absolute left-4 top-0 flex h-14 w-14 items-center justify-center rounded-full gradient-primary-soft sm:left-0 sm:h-16 sm:w-16">
                <Quote className="h-7 w-7 text-primary sm:h-8 sm:w-8" />
              </div>

              {/* Card */}
              <div className="flex items-center rounded-2xl border border-border bg-background p-6 shadow-soft sm:p-8 md:p-12">
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5 }}
                  className="w-full text-center sm:text-left"
                >
                  <p className="text-base leading-relaxed text-foreground sm:text-lg md:text-xl">
                    “{testimonial.content}”
                  </p>

                  <div className="mt-6 text-center font-semibold text-foreground/80 sm:mt-8 sm:text-left">
                    — {testimonial.author}
                  </div>
                </motion.div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};